import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { ConfigSystemParams, msSize, OurColors } from 'src/app/core/consts';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirmation-modal-form',
  templateUrl: './confirmation-modal-form.component.html',
  styleUrls: ['./confirmation-modal-form.component.scss']
})

export class ConfirmationModalFormComponent implements AfterViewInit, OnInit {
  
  @Input() animationLink      : string | undefined;
  @Input() imageColorSecondary: string | undefined;
  @Input() imageColorPrimary  : string | undefined;
  
  @Output() modalNo : EventEmitter<any>=new EventEmitter<any>();
  @Output() modalYes: EventEmitter<any>=new EventEmitter<any>();

  @ViewChild('confirmationModalForm', { static: false }) confirmationModalForm!: TemplateRef<void>;

  get colors            () { return `primary:${this.imageColorPrimary},secondary:${this.imageColorSecondary}`;         }
  get confirmTextMatches() { return this.confirmText==undefined
                                    || this.confirmTyped.trim().toLowerCase()===this.confirmText.trim().toLowerCase(); }

  get modalBackGround() { let value: string | boolean=this.configSystemService.getValue(ConfigSystemParams.ModalBackGround, "TRUE");
                          return value=value.toUpperCase()=="STATIC" ? "static" : (value.toUpperCase()=="TRUE" ? true : false) }

  private confirmationModalFormRef!: NgbModalRef;

  public confirmText               : string | undefined;
  public confirmTyped              : string="";
  public mainMessage               : string | undefined;
  public noText                    : string="No";
  public subMessage                : string | undefined;
  public yesText                   : string="Yes";

  constructor(
    private configSystemService: ConfigSystemService,
    private exceptionsService  : ExceptionsService,
    private modalService       : NgbModal
  ) {

  }

  public ngOnInit(): void {
    try {
      if (this.animationLink==undefined) {
        this.animationLink="https://cdn.lordicon.com/edcgvlnw.json"
      }
      
      if (this.imageColorSecondary==undefined) {
        this.imageColorSecondary=OurColors.Green;
      }
      
      if (this.imageColorPrimary==undefined) {
        this.imageColorPrimary=OurColors.DarkBlue;
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngAfterViewInit(): void {
    try {
      
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public openForm(mainMessage         : string,
                  subMessage          : string,
                  animationLink?      : string,
                  imageColorSecondary?: string,
                  imageColorPrimary?  : string,
                  yesText?            : string,
                  noText?             : string,
                  confirmText?        : string): void {
    try {
      this.confirmText =confirmText != undefined && confirmText.trim() != "" ? confirmText : undefined;
      this.confirmTyped="";

      if (animationLink != undefined)
        this.animationLink=animationLink;

      if (imageColorSecondary != undefined)
        this.imageColorSecondary=imageColorSecondary;

      if (imageColorPrimary != undefined)
        this.imageColorPrimary=imageColorPrimary;

      this.mainMessage=mainMessage != undefined && mainMessage.trim() != "" ? mainMessage : "Main Warning Message not set";
      this.noText     =noText      != undefined && noText.trim()      != "" ? noText      : "No";
      this.subMessage =subMessage  != undefined                             ? subMessage  : "Sub Warning Message not set";
      this.yesText    =yesText     != undefined && yesText.trim()     != "" ? yesText     : "Yes";

      this.confirmationModalFormRef=this.modalService.open(this.confirmationModalForm, { backdrop     : this.modalBackGround,
                                                                                         backdropClass: 'popup-on-top-backdrop',
                                                                                         centered     : true,
                                                                                         container    : 'body',
                                                                                         keyboard     : false,
                                                                                         size         : msSize.Small,
                                                                                         windowClass  : 'popup-on-top' });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public modalNoSelected(): void {
    try {
      this.modalNo.emit();
      this.confirmationModalFormRef.close();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public confirmTypedChanged(event: Event): void {
    try {
      this.confirmTyped=(<HTMLInputElement>event.target)?.value ?? "";
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public modalYesSelected(): void {
    try {
      if (!this.confirmTextMatches)
        return;

      this.modalYes.emit(this.confirmTyped.trim());
      this.confirmationModalFormRef.close();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
}
